module.exports = __webpack_public_path__ + "img/ns-icon-querynull.5ed65d40.png";